module.exports = __webpack_public_path__ + "img/cascader.af4b06f5.svg";